import { logger } from "@otto-ec/global-resources/debug";

export const moduleLogger = logger("benefit.tag");

export function generateRandomString(length: number): string {
	const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	return Array.from({ length }, () => characters.charAt(Math.floor(Math.random() * characters.length))).join("");
}
